import AbstractFetch from '~/repositories/AbstractFetch';
import type { IFetchOptions, IResponse } from '~/types/repositories';

interface IPostFormPayload {
  body: FormData | { type: string; data: Record<string, string> };
  headers?: Record<string, string>;
}

export default class FormFetch extends AbstractFetch {
  private static FORMS = 'v1/forms/';
  private static SERVICE_FORM = 'v1/form/service';

  constructor(fetchOptions: IFetchOptions) {
    super(fetchOptions.baseURL, fetchOptions.fetch);
  }

  async postForm(payload: IPostFormPayload): Promise<IResponse<{ id: number }>> {
    return this.fetch(FormFetch.FORMS, {
      method: 'POST',
      ...payload,
    });
  }

  async postServiceForm(body: FormData): Promise<IResponse<{ id: string }>> {
    return this.fetch(FormFetch.SERVICE_FORM, {
      method: 'POST',
      body,
    });
  }
}
